(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the blockname-block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @return  void
	 */
	var initializeBlock = function ($block) {};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		initializeBlock();
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=footer-block',
			initializeBlock
		);
	}
})(jQuery);
